/**
 * PageNav: 좌측 페이지 내 네비게이션 (클릭 시 해당 섹션으로 스크롤, 스크롤 스파이)
 */
export class PageNav {
    constructor(container = document.querySelector(".no-page-nav")) {
        this.container = container;
        if (!this.container) return;

        this.links = this.container.querySelectorAll(".no-page-nav__link[href^='#']");
        if (!this.links.length) return;

        this.sections = [];
        this.links.forEach((link) => {
            const id = link.getAttribute("href").slice(1);
            const section = id ? document.getElementById(id) : null;
            if (section) this.sections.push({ link, section });
        });

        this.init();
    }

    init() {
        this.bindClick();
        this.bindScrollSpy();
    }

    bindClick() {
        this.sections.forEach(({ link, section }) => {
            link.addEventListener("click", (e) => {
                e.preventDefault();
                section.scrollIntoView({ behavior: "smooth", block: "start" });
            });
        });
    }

    bindScrollSpy() {
        if (!this.sections.length) return;

        const setActive = () => {
            const top = window.scrollY + 120;
            let current = this.sections[0]?.link ?? null;
            for (let i = this.sections.length - 1; i >= 0; i--) {
                const { link, section } = this.sections[i];
                if (section.offsetTop <= top) {
                    current = link;
                    break;
                }
            }
            this.sections.forEach(({ link }) => link.classList.toggle("is-active", link === current));
        };

        setActive();
        window.addEventListener("scroll", () => setActive(), { passive: true });
    }
}
